class ProductHero extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.onClick = this.onClick.bind(this)

    this.els?.trigger?.element.addEventListener('click', this.onClick)
  }

  onClick () {
    const headerHeight = document.querySelector(`[data-section-type="header"]`)
    const scrollAmount = this.offsetHeight - headerHeight.offsetHeight

    window.scrollTo(0, `${scrollAmount}`)
  }
}

if (!customElements.get('product-hero')) {
  customElements.define('product-hero', ProductHero)
}
